import {Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {CommonService} from '../../../services/common.service';
import {NotificationService} from '../../../services/notification.service';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {FileService} from "../../../services/file.service";

@Component({
  selector: 'app-consent-print-dialog',
  templateUrl: './consent-print-dialog.component.html',
  styleUrls: ['./consent-print-dialog.component.scss']
})
export class ConsentPrintDialogComponent implements OnInit {
  public info: any;
  public loadedSate: boolean;
  public isLoading: boolean;
  contentWidth: any;
  public form: any;
  public jsonSObject: any;
  @ViewChild('divElement', {static: false}) divElement: ElementRef;
  @ViewChild('formContainer', {static: false}) formContainer: ElementRef;

  notificationId: number;
  formId: number;
  parentDisplayName: any;
  childDisplayName: any;
  childBirthday: any;
  consentTypeId: number;
  mode: string;
  parentId: number;
  childId: number;
  consent1: boolean;
  consent2: boolean;
  consent3: boolean;
  consentSliderItems: any;
  comments: string;
  commentArea: boolean;
  requiresConsent: boolean;
  // tslint:disable-next-line:variable-name
  has_full_info: boolean;
  // tslint:disable-next-line:variable-name
  unique_id: string;
  specificDate: any;
  hasDeadline: boolean;
  languageLevels: any;
  languages: any;
  selectedLanguage: any;
  hasForeignLanguage: any;
  hasMaxSlots: any;
  maxSlots: any;
  childInfo: any;
  parentInfo: any;
  // tslint:disable-next-line:variable-name
  has_two_factor: boolean;

  // tslint:disable-next-line:max-line-length
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private route: ActivatedRoute, private commonService: CommonService, private notificationService: NotificationService,
              // tslint:disable-next-line:max-line-length
              private router: Router, public location: Location, private renderer: Renderer2, public dialog: MatDialog, public toastMessagesService: ToastMessagesService, private fileService: FileService) {
    this.contentWidth = `width: ${window.innerWidth / 2}px`;
    this.loadedSate = false;
    this.isLoading = true;

    this.consent1 = false;
    this.consent2 = false;
    this.consent3 = false;

    this.consentSliderItems = [];
    this.commentArea = false;

    this.has_full_info = true;
    this.languageLevels = [{id: 1, level: 'Κανένα'}, {id: 2, level: 'Αρχάριος'}, {id: 3, level: 'Μεσαίο'}, {
      id: 4,
      level: 'Proficiency'
    }];

  }

  async ngOnInit() {
    this.comments = '';

    this.unique_id = this.data.unique_id;

    if (this.data.parentId) {
      await this.initParent(+this.data.parentId);
      this.parentId = +this.data.parentId;
    }

    if (this.data.childId) {
      await this.initChild(+this.data.childId);
      this.childId = +this.data.childId;
    }

    this.notificationId = +this.data.notificationId;

    this.mode = this.data.mode;
    await this.initializeForm();

    setTimeout(async () => {
      // const htmlJSONContent = JSON.stringify(this.formContainer.nativeElement.innerHTML);
      // try {
      //   this.fileService.onPostSave(`pdf/print`, {htmlJSONContent}, `reportTest.pdf`);
      //
      //   // await this.commonService.insertItem(`pdf/print`, {htmlJSONContent});
      // } catch (e) {
      //   this.toastMessagesService.toastErrorMessage(e.message);
      // }
      window.print();
    }, 5000);
  }

  // initialize Parent's Info
  async initParent(id: number) {
    try {
      const result = await this.commonService.getList(`people/parent?id=${id}`);
      this.parentInfo = result.object[0];
      this.parentInfo.displayName = `${this.parentInfo.first_name} ${this.parentInfo.last_name}`;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  // initialize Child's Info
  async initChild(id: number) {
    try {
      const result = await this.commonService.getList(`people/student?id=${id}`);
      this.childInfo = result.object[0];
      this.childInfo.displayName = `${this.childInfo.firstName} ${this.childInfo.lastName}`;

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initializeForm() {
    try {

      const contentRequest = await this.commonService.getList(`forms?unique_id=${this.unique_id}`);
      this.jsonSObject = JSON.parse(contentRequest.object[0].content);

      this.commentArea = this.jsonSObject.commentArea === true;

      this.requiresConsent = this.jsonSObject.requiresConsent;
      this.formId = contentRequest.object[0].id;
      this.has_full_info = contentRequest.object[0].has_full_info === 1;
      this.hasDeadline = contentRequest.object[0].has_deadline === 1;
      this.hasForeignLanguage = contentRequest.object[0].has_foreign_language === 1;
      this.hasMaxSlots = contentRequest.object[0].has_max_slots === 1;
      this.maxSlots = contentRequest.object[0].max_slots;
      this.has_two_factor = contentRequest.object[0].has_two_factor === 1;
      console.log(contentRequest.object[0]);
      if (this.hasForeignLanguage) {
        await this.initLanguages();
        const tempLanguages = this.languages.filter(language => language.id === contentRequest.object[0].language_id);
        console.log(tempLanguages);
        this.selectedLanguage = tempLanguages[0];
      }
      this.specificDate = contentRequest.object[0].deadline_date;
      this.consentSliderItems = this.jsonSObject.consentFields.filter(field => field.type === 'slider');

      for (const item of this.consentSliderItems) {
        item.value = item.value === 'true';
      }

      this.renderer.setProperty(this.divElement.nativeElement, 'innerHTML', this.jsonSObject.htmlContent);
      this.loadedSate = true;
      this.isLoading = false;
    } catch (e) {
      console.log(e.message);
    }
  }

  async initLanguages() {
    try {
      const questionsRequest = await this.commonService.getList('languages');
      this.languages = questionsRequest.object;
    } catch (e) {
      console.log(e.message);
    }
  }

  async submitConsent() {

  }

  async finalizeConsent() {

  }

  navigateBack() {

  }

  consentChange(item: any, event: any) {
    item.value = event.checked;
  }

  getParentInfo(parameter: string) {
    if (this.parentInfo && this.parentInfo.hasOwnProperty(parameter)) {
      return this.parentInfo[parameter];
    } else {
      return '';
    }
  }

  getChildInfo(parameter: string) {
    if (this.childInfo && this.childInfo.hasOwnProperty(parameter)) {
      return this.childInfo[parameter];
    } else {
      return '';
    }
  }
}
